import React from 'react';

interface PinIconProps {
  isPinned: boolean;
  onClick: (e: React.MouseEvent) => void;
  size?: number;
  disabled?: boolean;
  title?: string;
}

export const PinIcon: React.FC<PinIconProps> = ({
  isPinned,
  onClick,
  size = 20,
  disabled = false,
  title
}) => {
  const handleClick = (e: React.MouseEvent) => {
    console.log('[PIN DEBUG] PinIcon clicked, disabled:', disabled, 'isPinned:', isPinned);
    onClick(e);
  };

  return (
    <button
      className={`pin-button ${isPinned ? 'pinned' : 'unpinned'}`}
      onClick={handleClick}
      disabled={disabled}
      title={title || (isPinned ? 'Unpin' : 'Pin to top')}
      aria-label={isPinned ? 'Unpin' : 'Pin to top'}
    >
      {isPinned ? (
        // Filled pin icon (pinned state)
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z" />
        </svg>
      ) : (
        // Outline pin icon (unpinned state)
        <svg
          width={size}
          height={size}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z" />
        </svg>
      )}
    </button>
  );
};
